import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 10c11.8 0 23.5 2.3 34.4 6.9s20.8 11.2 29.2 19.5c8.4 8.4 15 18.3 19.5 29.2 4.5 10.9 6.9 22.6 6.9 34.4s-2.3 23.5-6.9 34.4-11.2 20.8-19.5 29.2c-8.4 8.4-18.3 15-29.2 19.5-10.9 4.5-22.6 6.9-34.4 6.9-23.9 0-46.8-9.5-63.6-26.4S10 123.9 10 100s9.5-46.8 26.4-63.6S76.1 10 100 10zm3.2 45H71.9v96.6h19.5v-36.4h12.7c8.8 0 15.6-.5 20.2-1.4 3.4-.8 6.8-2.3 10.1-4.6s6.1-5.5 8.2-9.5c2.1-4 3.2-9 3.2-15 0-7.7-1.9-14-5.6-18.8-3.4-4.6-8.3-8-13.9-9.5-3.3-.9-10.1-1.4-20.3-1.4h-2.8zm11.6 17c3 .5 5.8 2 7.9 4.3 2.1 2.3 3.1 5.2 3.1 8.7 0 2.9-.7 5.4-2.2 7.5-1.5 2.1-3.5 3.7-6.1 4.7-2.6 1-7.7 1.5-15.4 1.5H91.4V71.3h9.4c7 0 11.7.3 14 .7z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}